'use client'

import { getVND } from '@/utils/helpers'
import { Box, BoxProps, Stack, StackProps, Typography, TypographyOwnProps } from '@mui/material'
import { useMemo } from 'react'

interface PriceDisplayProps {
  productSelected?:
    | {
        attributes: IAttributeVariants[]
        product: Product
      }
    | null
    | undefined
  product?: {
    price_range?: {
      maximum_price?: {
        final_price?: { value: number }
        regular_price?: { value: number }
        discount?: { percent_off: number }
      }
    }
  } | null
  dataCartPriceRule?: {
    single_price?: number
  } | null
  tagProps?: Omit<BoxProps, 'children'>
  containerProps?: Omit<StackProps, 'children'>
  textPriceProps?: Omit<BoxProps, 'children'>
  textSalePriceProps?: Omit<TypographyOwnProps, 'children'>
  hidePriceSale?: boolean
}

export const PriceDisplay = ({
  productSelected,
  product,
  dataCartPriceRule,
  tagProps,
  containerProps,
  textPriceProps,
  textSalePriceProps,
  hidePriceSale = false,
}: PriceDisplayProps) => {
  // const dataPrice = useMemo(() => {
  //   return productSelected?.product?.price_range?.maximum_price ?? product?.price_range?.maximum_price
  // }, [productSelected?.product?.price_range?.maximum_price, product?.price_range?.maximum_price])
  // const salePrice = productSelected?.product?.daily_sale?.sale_price || 0
  // const caculatedPriceAfterVoucher = useMemo(() => {
  //   try {
  //     if (!dataCartPriceRule) return null
  //     if (!Object.keys(dataCartPriceRule).length) return null
  //     return dataCartPriceRule?.single_price
  //   } catch (error) {
  //     return dataPrice?.final_price?.value
  //   }
  // }, [dataCartPriceRule, dataPrice])

  // const isShowRegularPrice = useMemo(() => {
  //   if (caculatedPriceAfterVoucher) {
  //     return caculatedPriceAfterVoucher < (dataPrice?.final_price?.value || 0)
  //   }
  //   return (dataPrice?.regular_price?.value || 0) > (dataPrice?.final_price?.value || 0)
  // }, [caculatedPriceAfterVoucher, dataPrice?.final_price?.value, dataPrice?.regular_price?.value])

  // const isShowDiscount = useMemo(() => {
  //   if (caculatedPriceAfterVoucher) {
  //     return caculatedPriceAfterVoucher < (dataPrice?.final_price?.value || 0)
  //   }
  //   return (dataPrice?.discount?.percent_off || 0) > 0
  // }, [caculatedPriceAfterVoucher, dataPrice?.discount?.percent_off, dataPrice?.final_price?.value])

  // const theDiscountPercent = useMemo(() => {
  //   if (caculatedPriceAfterVoucher) {
  //     const discountValue = (dataPrice?.final_price?.value || 0) - caculatedPriceAfterVoucher
  //     return Math.round((discountValue / (dataPrice?.final_price?.value || 1)) * 100)
  //   }
  //   return dataPrice?.discount?.percent_off || 0
  // }, [caculatedPriceAfterVoucher, dataPrice?.discount?.percent_off, dataPrice?.final_price?.value])
  const price = useMemo(() => {
    const priceSale =
      productSelected?.product?.daily_sale?.sale_price ||
      productSelected?.product?.special_price ||
      product?.price_range?.maximum_price?.final_price?.value ||
      0
    const finalPrice =
      priceSale ||
      productSelected?.product?.price_range?.maximum_price?.final_price?.value ||
      product?.price_range?.maximum_price?.final_price?.value ||
      0
    const regularPrice =
      productSelected?.product?.price_range?.maximum_price?.regular_price?.value ||
      product?.price_range?.maximum_price?.regular_price?.value ||
      0

    return {
      final: finalPrice,
      regular: regularPrice,
      priceSale: priceSale,
    }
  }, [
    productSelected?.product?.daily_sale?.sale_price,
    productSelected?.product?.special_price,
    productSelected?.product?.price_range?.maximum_price?.final_price?.value,
    productSelected?.product?.price_range?.maximum_price?.regular_price?.value,
    product?.price_range?.maximum_price?.final_price?.value,
    product?.price_range?.maximum_price?.regular_price?.value,
  ])

  if (hidePriceSale) {
    return null
  }
  return (
    <Stack
      direction={'row'}
      justifyContent={{ xs: 'space-between', lg: 'flex-start' }}
      spacing={{ xs: 0, lg: 1 }}
      gap={{
        xs: 1,
        lg: 0,
      }}
      alignItems={{
        xs: 'center',
        lg: 'baseline',
      }}
      {...containerProps}
    >
      <Box
        className="main-price"
        sx={{ mt: '0 !important' }}
        fontWeight={600}
        lineHeight={1}
        fontSize={{
          xs: '1.5rem',
          md: '2rem',
        }}
        {...textPriceProps}
      >
        {!productSelected?.product?.daily_sale && (
          <span className="s align-middle">{getVND(price.final || 0, 'Đ')}</span>
        )}
        {productSelected?.product?.daily_sale && (
          <span className="s align-middle text-[#C84B00]">{getVND(price.priceSale || 0, 'Đ')}</span>
        )}
        <Typography
          component={'span'}
          sx={{ verticalAlign: 'baseline' }}
          fontSize={'0.5em'}
          fontWeight={400}
          color="#7b7b7b"
        >
          /Sản phẩm
        </Typography>
      </Box>

      {price.regular && price.regular > price.final && (
        <Box component={'span'}>
          <Typography
            fontWeight={400}
            color={'#707070'}
            sx={{
              verticalAlign: 'baseline',
              display: 'inline-block',
              position: 'relative',
            }}
            fontSize={'1rem'}
            className="discount-price"
            {...textSalePriceProps}
          >
            <Box
              lineHeight={'.5'}
              component="span"
              sx={{
                verticalAlign: 'baseline',
                textDecoration: 'line-through',
              }}
            >
              {getVND(price.regular || 0, 'Đ')}
            </Box>
          </Typography>
        </Box>
      )}
    </Stack>
  )
}
